import { IFilter } from '../models/Filter'
import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export const list = async ({ offset, filter }: IFilter) => {
  return httpRequest.get("/api/scf/request/supplier_led/requests", { offset, filter })
}
